import { __experimentalLinkControl as LinkControl } from '@wordpress/block-editor';
import { useEffect } from 'react';

const {
  i18n: { __ },
  element: { useState },
  components: { RadioControl },
} = wp;

const InternalExternalLink = (props) => {
  const { learnMoreLinkMetaValue, onMetaUpdate, showPopupMetaValue } = props;

  const learnMoreMetaValues = learnMoreLinkMetaValue || [];

  const { id, type, url, opensInNewTab } = learnMoreMetaValues;
  // eslint-disable-next-line no-nested-ternary
  let linkAction;

  if (showPopupMetaValue) {
    linkAction = 'popup';
  } else if (opensInNewTab?.[0] === '_blank') {
    linkAction = '_blank';
  } else {
    linkAction = '';
  }

  const [linkActions, setLinkActions] = useState(linkAction);

  const [learnMoreLink, setLearnMoreLink] = useState({
    id: id?.[0],
    url: url?.[0],
    type: type?.[0],
    opensInNewTab: opensInNewTab && opensInNewTab[0] ? opensInNewTab[0] : false, // NOSONAR
  });

  useEffect(() => {
    if (learnMoreLink.type === 'link') {
      onMetaUpdate('show_popup', false);
    }
  }, []); // eslint-disable-line

  return (
    <div className="components-base-control">
      <label
        htmlFor="featured-in-page"
        className={'components-base-control__label'}
      >
        Internal/External Link
      </label>
      <LinkControl
        id="featured-in-page"
        searchInputPlaceholder="Type here..."
        settings={[]}
        value={learnMoreLink}
        onRemove={() => {
          const updatedLearnMoreLink = {
            ...learnMoreLink,
            url: '',
          };
          setLearnMoreLink(updatedLearnMoreLink);
          onMetaUpdate('learn_more_link', updatedLearnMoreLink);
        }}
        onChange={(selection) => {
          const updatedLearnMoreLink = {
            ...learnMoreLink,
            ...selection,
          };
          setLearnMoreLink(updatedLearnMoreLink);
          onMetaUpdate('learn_more_link', updatedLearnMoreLink);
        }}
        withCreateSuggestion={false}
      />

      <RadioControl
        label={__('Read More Link Action')}
        selected={linkActions}
        hideLabelFromVision={true}
        className={'read-more-link-action'}
        options={[
          { label: 'Open in the same tab', value: '' },
          { label: 'Open in a new tab', value: '_blank' },
          { label: 'Open as a popup', value: 'popup' },
        ]}
        onChange={(value) => {
          const popupValue = value === 'popup' ? true : false;
          onMetaUpdate('show_popup', popupValue);

          const updatedLearnMoreLink = {
            ...learnMoreLink,
            opensInNewTab: value,
          };
          setLearnMoreLink(updatedLearnMoreLink);
          onMetaUpdate('learn_more_link', updatedLearnMoreLink);
          setLinkActions(value);
        }}
      />
      <p className="components-panel__help-text">
        {__(
          'The popup function enables interaction with images, videos, YouTube, Vimeo, and web pages that support embedding',
          'b3rg',
        )}
      </p>
    </div>
  );
};

export default InternalExternalLink;
